var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "transactions-list-modal" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.dialogVisible,
                "append-to-body": false,
                "close-on-click-modal": false,
                width: "700px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("components.detail")))]),
                  _c(
                    "el-tag",
                    {
                      staticClass: "tag-custom link-tag",
                      attrs: {
                        type: _vm.getCheckoutOrderStatusMap(_vm.status).type,
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getCheckoutOrderStatusMap(_vm.status).label
                          )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "total" }, [
                _c("div", { staticClass: "num-container" }, [
                  _c("div", { staticClass: "txt" }, [
                    _vm._v(_vm._s(_vm.$t("payment_links.order_amount"))),
                  ]),
                  _c("div", { staticClass: "num" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$store.getters.currency || "PHP") +
                        " " +
                        _vm._s(_vm._f("toDivideWithDot")(_vm.amount)) +
                        " "
                    ),
                  ]),
                ]),
              ]),
              _c(
                "el-tabs",
                {
                  staticClass: "tab-container",
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.overview"),
                        name: "Order",
                      },
                    },
                    [
                      _c("Order", {
                        key: "Order",
                        tag: "Order",
                        attrs: { "order-data": _vm.orderData },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.checkout_details"),
                        name: "CheckoutDetail",
                      },
                    },
                    [
                      _c("CheckoutDetail", {
                        key: "CheckoutDetail",
                        tag: "CheckoutDetail",
                        attrs: { "transaction-data": _vm.transactionData },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("payment_links.transaction_details"),
                        name: "TransactionDetail",
                      },
                    },
                    [
                      _c("TransactionDetail", {
                        key: "TransactionDetail",
                        tag: "TransactionDetail",
                        attrs: { "transaction-data": _vm.transactionData },
                        on: { onClickDetailBtn: _vm.onClickDetailBtn },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("PaymentDetailsModal", {
        ref: "paymentDetailsModal",
        attrs: { "detail-id": _vm.detailId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }